export enum Role {
    Supplier = "supplier",
    Vendor = "vendor",
}
